export default __webpack_public_path__ + "static/1270-99cc6f7c8a715d44ce48ea1748543174.png";